import { apiClient, type ApiClientResponse, routes } from 'common/services';
import { type ProfileDataObject } from 'models/service/user';

export const currentUser = async () =>
  apiClient.get<ProfileDataObject, ApiClientResponse<ProfileDataObject>>(routes.user.current);
